import { useContext } from "react";
import { KustomerChatSupportContext } from "../contexts";

export function useKustomerChatSupport() {
  const context = useContext(KustomerChatSupportContext);
  if (!context) {
    // safe error handling for tenant apps that haven't wrapped their app in the ChatSupportProvider yet
    console.error(
      "KustomerChatSupportProvider is missing in the DOM tree for this travel portal."
    );

    return {};
  }
  return context;
}
